import axios, {estimation} from "./api"
import isEmpty from "lodash/isEmpty";

export const bookletApi = {
    getBookletById(request) {
        return axios.get(`/api/booklets/${request.bookletId}?range_start=${request.rangeStart}&result_limit=${request.resultLimit}`);
    },
    getBookletCollaborations() {
        return axios.get(`/api/booklets/collaborations`);
    },
    getBookletCollection(rangeStart = 0, resultLimit = 20, sortBy = 'updated_at') {
        return axios.get(`/api/booklets/collection`, {
            params: { range_start: rangeStart, result_limit: resultLimit, sort_by: sortBy }
        });
    },
    getRecentlyUsedCollections() {
        return axios.get(`/api/booklets/recently-used`);
    },
    postBookletAddCreature(request, estimate = false, title, estimateCallback = null) {
        return estimation(`/api/booklets/${request.booklet_id}/add-creature`, request, estimate, title, estimateCallback);
    },
    postBookletAddNpc(request, estimate = false, title, estimateCallback = null) {
        return estimation(`/api/booklets/${request.booklet_id}/add-npc`, request, estimate, title, estimateCallback);
    },
    postBookletAddCharacter(request, estimate = false, title, estimateCallback = null) {
        return estimation(`/api/booklets/${request.booklet_id}/add-character`, request, estimate, title, estimateCallback);
    },
    postCreateBooklet(request) {
        return axios.post(`/api/booklets/create`, request);
    },
    patchUpdateBooklet(request) {
        return axios.patch(`/api/booklets/${request.booklet_id}/update`, request);
    },
    deleteBooklet(request) {
        return axios.delete(`/api/booklets/${request.booklet_id}/delete`);
    },
    removeCreature(request) {
        return axios.delete(`/api/booklets/${request.booklet_id}/remove-creature`, {
            params: { creature_id: request.creature_id }
        });
    },
    removeNpc(request) {
        console.log(request)
        return axios.delete(`/api/booklets/${request.booklet_id}/remove-npc`, {
            params: { npc_id: request.npc_id }
        });
    },
    removeCharacter(request) {
        return axios.delete(`/api/booklets/${request.booklet_id}/remove-character`, {
            params: { character_id: request.character_id }
        });
    }
}
